import FournisseurForm from "../Fournisseur/FournisseurForm";
import "../Reception/ReceptionCompact.css";
import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row, CardBody, Card } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { receiptNoteActions } from "../../sagas/receiptNoteSlice";
import { supplierActions } from "../../sagas/supplierSlice";
import { entrepotActions } from "../../sagas/entrepotSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import ReceptionLines from "./ReceptionLines";
import { formatPrice } from "../../helpers/utility";
import { FaWarehouse, FaUser, FaMoneyBillWave } from "react-icons/fa";
import "./pos-reception-form.css";
import POSKeypadModal from "./POSKeypadModal";
import SupplierSelectModal from "./SupplierSelectModal";

import { categoryActions } from "../../sagas/categorySlice";
import { productActions } from "../../sagas/productSlice";




const ReceiptNoteNew = ({ onClose, reception }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { suppliers } = useSelector(s => s.suppliers);
    const { entrepots } = useSelector(s => s.entrepots);

    const [supplierModal, setSupplierModal] = useState(false);
    const [entrepotModal, setEntrepotModal] = useState(false);
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const [docKeypadOpen, setDocKeypadOpen] = useState(false);
    const [docKeypadValue, setDocKeypadValue] = useState("");
    const [categoryModal, setCategoryModal] = useState(false);

    const openDeliveryNoteKeypad = () => {
        setDocKeypadValue(values.deliveryNoteNb || "");
        setDocKeypadOpen(true);
    };

    useEffect(() => {
        dispatch(supplierActions.search({ query: "" }));
        dispatch(entrepotActions.list());
        dispatch(categoryActions.list({ query: "" }));
        dispatch(productActions.findAllUnites());
    }, []);

    const formik = useFormik({
        initialValues: {
            fournisseurId: reception?.fournisseurId || null,
            fournisseurNom: reception?.fournisseurNom || "",
            entrepotId: reception?.entrepotId || null,
            dateReception: reception?.dateReception || new Date().toISOString().split("T")[0],
            deliveryNoteNb: reception?.deliveryNoteNb || "",
            modeReglement: reception?.modeReglement || "ESPECES",
            lignes: reception?.lignes || [],
            montantTotalHT: reception?.montantTotalHT || 0,
            montantTotalTaxe: reception?.montantTotalTaxe || 0,
            montantTotalTTC: reception?.montantTotalTTC || 0,
            statut: reception?.statut || "EN_ATTENTE",
        },
        validationSchema: Yup.object({
            fournisseurId: Yup.number().nullable().required("Choisissez une valeur."),
            entrepotId: Yup.number().nullable().required("Choisissez une valeur."),
            deliveryNoteNb: Yup.string().required("Saisissez le numéro du bon fournisseur."),
            lignes: Yup.array().min(1, "Ajoutez au moins un article."),
        }),
        onSubmit: values => {
            const payload = {
                data: values,
                onSuccess: () => {
                    Swal.fire("OK", "Réception enregistrée", "success");
                    onClose();
                }
            };
            reception
                ? dispatch(receiptNoteActions.updateReceiptNote({ ...payload, id: reception.id }))
                : dispatch(receiptNoteActions.createReceiptNote(payload));
        }
    });

    const { values, setFieldValue, handleSubmit } = formik;

    const isReadOnly = values.statut === "VALIDE";

    return (
        <>
            <Form onSubmit={handleSubmit} className="pos-form reception-compact reception-form">
                {isReadOnly && (
                    <div className="pos-locked-banner">
                        🔒 Réception validée — modification impossible
                    </div>
                )}
                {/* ================= HEADER CARD ================= */}
                <Card className="pos-card shadow-sm mb-2">
                    <CardBody className="p-2">

                        <Row className="g-2">
                            <Col md={4}>
                                <Label className="pos-label">Fournisseur</Label>
                                <Button color="light" block className="pos-select-btn" onClick={() => !isReadOnly && setSupplierModal(true)}
                                    disabled={isReadOnly}>
                                    <FaUser /> {values.fournisseurNom || "Choisir fournisseur"}
                                </Button>
                            </Col>

                            <Col md={4}>
                                <Label className="pos-label">Lieu de stockage</Label>
                                <Button
                                    color="light"
                                    block
                                    className="pos-select-btn"
                                    onClick={() => !isReadOnly && setEntrepotModal(true)}
                                    disabled={isReadOnly}
                                >
                                    <FaWarehouse /> {entrepots.find(e => e.id === values.entrepotId)?.libelle || "Choisir le lieu de stockage"}
                                </Button>
                            </Col>

                            <Col md={4}>
                                <Label className="pos-label">Date réception</Label>
                                <Input
                                    type="date"
                                    value={values.dateReception}
                                    onChange={e => setFieldValue("dateReception", e.target.value)}
                                    className="pos-input"
                                    disabled={isReadOnly}
                                />
                            </Col>

                            <Col md={4}>
                                <div
                                    className={`pos-field ${isReadOnly ? "pos-disabled" : ""}`}
                                    onClick={() => !isReadOnly && openDeliveryNoteKeypad()}
                                >
                                    <div className="pos-field-label">
                                        📄 N° du bon fournisseur *
                                    </div>
                                    <div className="pos-field-value">
                                        {values.deliveryNoteNb || "Toucher pour saisir"}
                                    </div>
                                </div>
                            </Col>

                            <Col md={8}>
                                <Label className="pos-label">Paiement</Label>
                                <div className="d-flex gap-2 flex-wrap">
                                    {["ESPECES", "CHEQUE", "VIREMENT"].map(m => (
                                        <Button
                                            key={m}
                                            color={values.modeReglement === m ? "primary" : "light"}
                                            onClick={() => !isReadOnly && setFieldValue("modeReglement", m)}
                                            disabled={isReadOnly}
                                            className="pos-mode-btn"
                                        >
                                            <FaMoneyBillWave /> {{ ESPECES: "Espèces", CHEQUE: "Chèque", VIREMENT: "Virement" }[m]}
                                        </Button>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                    </CardBody>
                </Card>


                {formik.submitCount > 0 && Object.keys(formik.errors).length > 0 && <div className="alert alert-danger py-2" role="alert">Vérifiez le fournisseur, le lieu de stockage et le numéro du bon. Ajoutez au moins un article.</div>}
                {/* ================= LINES CARD ================= */}
                <Card className="pos-card shadow-sm mb-2 pos-lines-card">
                    <CardBody className="p-2">
                        <ReceptionLines formik={formik} readOnly={isReadOnly} />
                    </CardBody>
                </Card>


                {/* ================= FOOTER BAR ================= */}
                <Card className="pos-footer-bar shadow-sm">
                    <CardBody className="p-2">

                        <Row className="align-items-center">
                            <Col md={6} className="pos-totals">
                                <div>HT : <strong>{formatPrice(values.montantTotalHT)}</strong></div>
                                <div>TVA : <strong>{formatPrice(values.montantTotalTaxe)}</strong></div>
                                <div>TTC : <strong className="text-primary">{formatPrice(values.montantTotalTTC)}</strong></div>
                            </Col>

                            <Col md={6} className="text-end">
                                <Button color="secondary" className="me-2 pos-action-btn" onClick={onClose}>
                                    Annuler
                                </Button>
                                {!isReadOnly && (
                                    <Button color="primary" type="submit" className="pos-action-btn">
                                        Enregistrer
                                    </Button>
                                )}
                            </Col>
                        </Row>

                    </CardBody>
                </Card>

            </Form>



            {/* ENTREPOT LIST */}
            <Modal isOpen={entrepotModal} toggle={() => setEntrepotModal(false)} className="reception-compact-modal">
                <ModalHeader>Choisir Lieu de stockage</ModalHeader>
                <ModalBody>
                    {entrepots.map(e => (
                        <Button key={e.id} block color="light"
                            onClick={() => { setFieldValue("entrepotId", e.id); setEntrepotModal(false); }}>
                            {e.code} - {e.libelle}
                        </Button>
                    ))}
                </ModalBody>
            </Modal>




            <Modal isOpen={showSupplierModal} toggle={() => setShowSupplierModal(false)} size="lg" className="reception-compact-modal">
                <ModalHeader toggle={() => setShowSupplierModal(false)}>Nouveau fournisseur</ModalHeader>
                <ModalBody>
                    <FournisseurForm embedded onCancel={() => setShowSupplierModal(false)} onSaved={supplier => {
                        setFieldValue('fournisseurId', supplier.id);
                        setFieldValue('fournisseurNom', supplier.typeFournisseur === 'ENTREPRISE' ? supplier.entreprise : [supplier.nom, supplier.prenom].filter(Boolean).join(' '));
                        dispatch(supplierActions.search({ query: '' }));
                        setShowSupplierModal(false);
                    }} />
                </ModalBody>
            </Modal>
            <SupplierSelectModal
                isOpen={supplierModal}
                toggle={() => setSupplierModal(false)}
                suppliers={suppliers}
                selectedSupplier={suppliers.find(s => s.id === values.fournisseurId)}

                onSelect={(s) => {
                    if (!s) {
                        setFieldValue("fournisseurId", null);
                        setFieldValue("fournisseurNom", "");
                        return;
                    }

                    setFieldValue("fournisseurId", s.id);
                    setFieldValue("fournisseurNom", s.nom || s.entreprise);
                }}

                onAddNew={() => {
                    setSupplierModal(false);
                    setTimeout(() => setShowSupplierModal(true), 300);
                }}
            />

            <POSKeypadModal
                isOpen={docKeypadOpen}
                toggle={() => setDocKeypadOpen(false)}
                value={docKeypadValue}
                onChange={setDocKeypadValue}
                onSearch={(val) => {
                    setFieldValue("deliveryNoteNb", docKeypadValue);
                    setDocKeypadOpen(false);
                }}
                title="Numéro Bon Livraison"
            />


        </>
    );
};

export default ReceiptNoteNew;
